import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintLabelContentComponent } from '../print-label-content.component';
import { Avery94200LabelStackContentViewModel } from './avery-94200-label-stack-content-view-model';

@Component({
  selector: 'app-avery-94200-label-stack-content',
  templateUrl: './avery-94200-label-stack-content.component.html',
  styleUrl: './avery-94200-label-stack-content.component.scss',
  providers: [Avery94200LabelStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class Avery94200LabelStackContentComponent extends PrintLabelContentComponent {
  constructor(
    public viewModel: Avery94200LabelStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
